import Cropper from "react-easy-crop";
import {IconButton} from "../../../../shared/components";
import {ChangeEvent, useContext, useState} from "react";
import {ImageContext} from "../../../../shared/tools/image/imageContext";

export interface IProps {
  handleSelectFile: (event: ChangeEvent<HTMLInputElement>) => void;
  setCroppedAreaPixels: (x: any) => void;
  imageUrl: string;
}

export const CropComponent = ({
  handleSelectFile,
  imageUrl,
  setCroppedAreaPixels
  }: IProps) => {
  const [crop, setCrop] = useState({x: 0, y: 0});
  const [zoom, setZoom] = useState(1);
  const [rotation, setRotation] = useState(0);
  const {size} = useContext(ImageContext);

  const onCropComplete = (croppedArea: any, croppedAreaPixels: any) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }

  const handleRotate = () => {
    setRotation((rotation + 270) % 360);
  }

  const handleZoomUp = () => {
    let newZoom = zoom + .2;
    if (newZoom > 6) {
      newZoom = 6;
    }
    setZoom(newZoom);
  }


  const handleZoomDown = () => {
    let newZoom = zoom - .2;
    if (newZoom < 1) {
      newZoom = 1;
    }
    setZoom(newZoom);
  }

  return (
    <div className="crop-container">
      <div className="cropper-wrapper">
        <Cropper
          image={imageUrl}
          crop={crop}
          zoom={zoom}
          rotation={rotation}
          aspect={size.w / size.h}
          onCropChange={setCrop}
          onCropComplete={onCropComplete}
          onZoomChange={setZoom}
          showGrid={true}
        />
      </div>
      <div className="crop-controls-container">
        <div className="crop-controls-wrapper">
          <div className="crop-control left">
            <IconButton icon='upload' label>
              <input hidden accept="image/*" multiple type="file" onChange={handleSelectFile}/>
            </IconButton>
            <IconButton
              icon='rotateCCW'
              onClick={handleRotate}
            />
          </div>
          <div className="crop-control right">
            <IconButton
              icon='plus'
              onClick={handleZoomUp}
            />
            <IconButton
              icon='minus'
              onClick={handleZoomDown}
            />

          </div>
        </div>
      </div>

    </div>
  );
}
